import { NextRouter, useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { matchSourceSegmentCTFM, FORM_PAGE } from '@chegg-wt/core/utils/routes'

const getPage = (router: NextRouter) => {
  const { source: sourceQuery } = router.query as { source: string }
  return matchSourceSegmentCTFM(sourceQuery).params.page
}

const useCurrentPage = () => {
  const router = useRouter()
  const page = getPage(router)
  const [currentPage, setCurrentPage] = useState<string>(page)

  useEffect(() => {
    const page = getPage(router)
    if (page === FORM_PAGE.NEW || page === FORM_PAGE.EVAL || page === FORM_PAGE.MANUAL) {
      setCurrentPage(page)
    }
  }, [router.query.source])

  return currentPage
}

export default useCurrentPage
